<template>
	<Menu as="div" class="relative inline-block text-left">
		<div>
			<MenuButton
				ref="buttonRef"
				class="flex items-center rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-mabey-500 focus:ring-offset-2 focus:ring-offset-gray-100"
				@click="adjustPosition">
				<span class="sr-only">Open options</span>
				<EllipsisVerticalIcon class="h-5 w-5" aria-hidden="true" />
			</MenuButton>
		</div>

		<Teleport to="body" :disabled="!teleport">
			<transition
				enter-active-class="transition ease-out duration-100"
				enter-from-class="transform opacity-0 scale-95"
				enter-to-class="transform opacity-100 scale-100"
				leave-active-class="transition ease-in duration-75"
				leave-from-class="transform opacity-100 scale-100"
				leave-to-class="transform opacity-0 scale-95">
				<MenuItems
					ref="itemsRef"
					:class="[
						'w-56 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
						teleport ? '' : 'absolute right-0 z-10 mt-2 origin-top-right'
					]">
					<div class="py-1">
						<slot />
					</div>
				</MenuItems>
			</transition>
		</Teleport>
	</Menu>
</template>

<script setup lang="ts">
	import { Menu, MenuButton, MenuItems } from '@headlessui/vue'
	import { EllipsisVerticalIcon } from '@heroicons/vue/20/solid'
	import { ref, nextTick } from 'vue'

	const props = withDefaults(
		defineProps<{
			teleport?: boolean
		}>(),
		{
			teleport: true
		}
	)

	const buttonRef = ref()
	const itemsRef = ref()

	const adjustPosition = () => {
		if (!props.teleport) return

		nextTick(() => {
			const buttonEl = buttonRef.value?.$el
			const itemsEl = itemsRef.value?.$el

			if (!buttonEl || !itemsEl) return

			const buttonRect = buttonEl.getBoundingClientRect()
			const itemsRect = itemsEl.getBoundingClientRect()

			itemsEl.style.position = 'fixed'
			itemsEl.style.zIndex = '9999'

			// Vertical
			const spaceBelow = window.innerHeight - buttonRect.bottom
			const spaceAbove = buttonRect.top

			if (spaceBelow < itemsRect.height && spaceAbove > spaceBelow) {
				// Above
				itemsEl.style.top = buttonRect.top - itemsRect.height - 4 + 'px'
				itemsEl.style.transformOrigin = 'bottom right'
			} else {
				// Below
				itemsEl.style.top = buttonRect.bottom + 4 + 'px'
				itemsEl.style.transformOrigin = 'top right'
			}

			// Horizontal (Right aligned)
			itemsEl.style.left = buttonRect.right - itemsRect.width + 'px'
		})
	}
</script>
